import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// Component này nhận vào danh sách các role được phép truy cập
const ProtectedRoute = ({ allowedRoles }) => {
  // 1. Lấy thông tin user từ localStorage (hoặc Context/Redux của bạn)
  // Giả sử khi login bạn lưu object user dạng: { name: "A", role: "staff", ... }
  const userStr = sessionStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  // 2. Nếu chưa đăng nhập -> Đá về trang Login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 3. Nếu đã đăng nhập nhưng sai quyền (VD: admin định vào trang staff)
  // -> Đá về trang 403 hoặc trang chủ của họ
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Nếu là admin mà vào nhầm trang staff -> Về dashboard
    if (user.role === 'admin') return <Navigate to="/dashboard" replace />;
    // Nếu là staff mà vào nhầm trang admin -> Về counter
    if (user.role === 'staff') return <Navigate to="/counter" replace />;
    
    return <Navigate to="/unauthorized" replace />;
  }

  // 4. Nếu hợp lệ -> Cho phép hiển thị nội dung con (Outlet)
  return <Outlet />;
};

export default ProtectedRoute;